import { addToGlobalThisRet } from "@plugins";

function departmentEmployeesCounter() {
    const photosWrap = document.querySelector(".js-department-employees-photos");

    if (photosWrap && photosWrap.children.length > 10) {
        const difference = document.createElement("div");

        difference.classList.add("profile-info__difference-employees-count");
        difference.innerHTML = `+${photosWrap.children.length - 10}`;
        photosWrap.appendChild(difference);

        const showAllBtn = document.querySelector(".js-department-employees-show-all");

        if (showAllBtn) {
            showAllBtn.style.display = "flex";
        }
    }
}

window.addEventListener("load", () => {
    departmentEmployeesCounter();
});

addToGlobalThisRet(departmentEmployeesCounter, "departmentEmployeesCounter");
